import routes from '../../../route_names'
import { getDefaultInterval } from '@/helpers/filter'

export default {
  path: 'projects/:projectId/campaigns/:campaignId/proof',
  name: routes.PROOF,
  component: () =>
    import(/* webpackChunkName: "dashboard" */ './ProofView.vue'),
  meta: {
    layout: 'dashboard/DashboardLayout',
    requiresAuth: true,
    requiredRole: 'ADMIN',
    defaultChild: routes.PROOF_APPEARANCE
  },

  children: [
    {
      path: 'appearance',
      name: routes.PROOF_APPEARANCE,
      component: () =>
        import(/* webpackChunkName: "dashboard" */ './AppearanceWidgetTwoColumn.vue'),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN',
        requireDateFilter: true
      }
    },
    {
      path: 'cards',
      name: routes.PROOF_CARDS,
      component: () =>
        import(/* webpackChunkName: "dashboard" */ './SelectCards.vue'),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN',
        requireDateFilter: true
      },
      children: [
        {
          path: 'nps',
          name: routes.PROOF_CARDS_NPS,
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */ './ProofView.vue'
            ),
          meta: {
            layout: 'dashboard/DashboardLayout',
            requiresAuth: true,
            requiredRole: 'ADMIN',
            requireDateFilter: true
          }
        },
        {
          path: 'csat',
          name: routes.PROOF_CARDS_CSAT,
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */ './ProofView.vue'
            ),
          meta: {
            layout: 'dashboard/DashboardLayout',
            requiresAuth: true,
            requiredRole: 'ADMIN',
            requireDateFilter: true
          }
        },
        {
          path: 'ces',
          name: routes.PROOF_CARDS_CES,
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */ './ProofView.vue'
            ),
          meta: {
            layout: 'dashboard/DashboardLayout',
            requiresAuth: true,
            requiredRole: 'ADMIN',
            requireDateFilter: true
          }
        }
      ]
    },
    {
      path: 'settings',
      name: routes.PROOF_SETTINGS,
      component: () =>
        import(/* webpackChunkName: "dashboard" */ './Settings.vue'),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN',
        requireDateFilter: true
      }
    },
    {
      path: 'integrations',
      name: routes.PROOF_INTEGRATIONS,
      component: () =>
        import(/* webpackChunkName: "dashboard" */ './IntegrationsView.vue'),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN',
        requireDateFilter: true
      }
    },
    {
      path: 'publish',
      name: routes.PROOF_PUBLISH,
      component: () =>
        import(/* webpackChunkName: "dashboard" */ './ProofPublish.vue'),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN',
        requireDateFilter: true
      }
    }
  ]
}
